import { usStateOptionsMessages } from './usStateOptionsMessages';

export const stateOptionsMessages = {
    US: usStateOptionsMessages
};

export const stateOptions = ({formatMessage, countryCode}) => [
    {value: '', label: ''},
    ...Object.keys(stateOptionsMessages[countryCode || 'US']).map(code => ({
        value: code,
        label: formatMessage(stateOptionsMessages[countryCode || 'US'][code])
    }))
];
